import { useNavigate } from "react-router";
import { scenes } from "../../constants/app.config";
import { Screen, usePodContext } from "../PodContext";
import Footer from "./Footer";
import GoHomeTimer from "./GoHomeTimer";
import Header from "./Header";
import "./SelectScene.css";

interface Scene {
  title: string;
  preview: string;
}

const SelectScene = () => {
  const navigate = useNavigate();
  const { setScene } = usePodContext();

  const selected = (scene: Scene) => {
    setScene(scene);
    navigate(Screen.SELECT_AUDIO);
  };

  return (
    <div className="image-bg-container">
      <GoHomeTimer />
      <Header totalSteps={4} title="Choose your oasis" progress={3} />
      <div className="vr-select-scene-container">
        <div className="vr-select-scene-carousel">
          {scenes.map((scene: Scene) => (
            <button
              key={scene.title}
              className="vr-select-scene-option"
              style={{ backgroundImage: `url(${scene.preview})` }}
              onClick={() => selected(scene)}
              aria-label="Select oasis"
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SelectScene;
